const AUTH_STORAGE_KEY = 'lottery_admin_auth';

export interface AdminLoginUser {
  id?: number;
  loginName?: string;
  name?: string;
  sdkProductId?: number;
  [key: string]: any;
}

export interface AuthTokens {
  accessToken: string;
  refreshToken: string;
  accessTokenExpireAt: number;
  refreshTokenExpireAt: number;
  loginUser?: AdminLoginUser;
}

export const authStorage = {
  get(): AuthTokens | null {
    const raw = localStorage.getItem(AUTH_STORAGE_KEY);
    if (!raw) {
      return null;
    }

    try {
      return JSON.parse(raw) as AuthTokens;
    } catch (error) {
      localStorage.removeItem(AUTH_STORAGE_KEY);
      return null;
    }
  },

  set(tokens: AuthTokens) {
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(tokens));
  },

  clear() {
    localStorage.removeItem(AUTH_STORAGE_KEY);
  },

  isLoggedIn() {
    const tokens = authStorage.get();
    return Boolean(tokens?.accessToken && tokens.refreshTokenExpireAt > Date.now());
  },
};
